import React from 'react';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import passed from '../../../assets/img/performances/PASSED@2x.png';
import failed from '../../../assets/img/performances/FAILED@2x.png';
import unmarked from '../../../assets/img/performances/UNMARKED_2.png';
import passedDisabled from '../../../assets/img/performances/PASSED-GREYSCALE@2x.png';
import failedDisabled from '../../../assets/img/performances/FAILED-GREYSCALE@2x.png';

function tooltip(info, active) {
  return (
    <Tooltip id='tooltip' className={active ? 'red' : 'light-grey'}>
      {info}
    </Tooltip>
  );
}

const PriceItTable = ({
  name, active, price_outlets: priceOutlets, price_list: priceList, price_rrp: priceRrp
}) => {
  const rows = {
    label: '',
    price_rrp_yn: 'Price RRP',
    price_list_yn: 'Price List',
    price_passed_yn: 'Price IT Overall Result',
    points: 'Points Awarded'
  };

  function getContent(row, outlet) {
    switch (row) {
      case 'price_rrp_yn':
      case 'price_list_yn':
      case 'price_passed_yn':
        switch (outlet[row]) {
          case 'Y':
            return (
              <OverlayTrigger placement='top' overlay={tooltip('Pass', active)}>
                <img className="article-image" src={active ? passed : passedDisabled}/>
              </OverlayTrigger>
            );
          case 'N':
            return (
              <OverlayTrigger placement='top' overlay={tooltip('Fail', active)}>
                <img className="article-image" src={active ? failed : failedDisabled}/>
              </OverlayTrigger>
            );
          default:
            return (
              <OverlayTrigger placement='top' overlay={tooltip('Not assessed')}>
                <img className="article-image" src={unmarked}/>
              </OverlayTrigger>
            );
        }
      case 'points':
        return <span className={active ? 'performance-points' : 'performance-points-disabled'}><b>{outlet[row]}</b></span>;
      default:
        return outlet[row];
    }
  }

  return (
    <Row className="performance-table text-center">
      <div className="flex-container">
        {!active && <div className="locked" />}
        <div className="price-it-objective-name">
          <b>{name} {priceList} {priceRrp}</b>
        </div>
      </div>
      {
        Object.keys(rows).map(key => (
          (priceList === true || key !== 'price_list_yn') && (priceRrp === true || key !== 'price_rrp_yn') &&
          (
            <Row className={key === 'label' ? 'performance-label' : 'performance-row'} key={key}>
              <Col className="text-right col-md-3 col-sm-3 col-xs-3" style={{minHeight: '1em'}}>{rows[key]}</Col>
              {
                priceOutlets.map((outlet, index) => (
                  <Col
                    id={index}
                    className={index >= 3 ? 'col-md-1 hidden-sm hidden-xs' : 'col-md-1 col-sm-3 col-xs-3'}
                    key={outlet.id}
                  >
                    {getContent(key, outlet)}
                  </Col>
                ))
              }
            </Row>)
        ))
      }
    </Row>
  );
};

export default PriceItTable;



// WEBPACK FOOTER //
// ./src/components/store-performance/price-it/price-it-table.jsx